import { percentChange } from "./format";

export type MoverInput = {
  merchantId: string;
  currency: string;
  currentGmv: number;
  priorGmv: number;
  factor: number | null;
};

export type Mover = { merchantId: string; currency: string; diff: number; converted: number; change: number | null };

const MOVERS_PER_GROUP = 3;

export const biggestMovers = (merchants: MoverInput[]): { gaining: Mover[]; declining: Mover[] } => {
  const movers = merchants.flatMap((merchant) => {
    if (merchant.factor === null) return [];
    const diff = merchant.currentGmv - merchant.priorGmv;
    return [
      {
        merchantId: merchant.merchantId,
        currency: merchant.currency,
        diff,
        converted: diff * merchant.factor,
        change: percentChange(merchant.currentGmv, merchant.priorGmv),
      },
    ];
  });

  return {
    gaining: movers
      .filter((mover) => mover.converted > 0)
      .sort((a, b) => b.converted - a.converted)
      .slice(0, MOVERS_PER_GROUP),
    declining: movers
      .filter((mover) => mover.converted < 0)
      .sort((a, b) => a.converted - b.converted)
      .slice(0, MOVERS_PER_GROUP),
  };
};
